import { getMemberIdWithFallback } from '@trello/authentication';

import { useCachedMemberCohorts } from 'app/src/components/TrelloOnline/useCachedMemberCohorts';

export const usePersonalProductivityCohortValue = () => {
  const memberId = getMemberIdWithFallback();

  const userCohorts = useCachedMemberCohorts(memberId);

  return userCohorts?.cohorts?.userCohortPersonalProductivity;
};
